export default __webpack_public_path__ + "static/media/import.18ab14f1.md";